import { UploadFile } from "@king-ict/eupisi-ui/models/UploadFile";

import { CommitteeEmployee } from "../Committee";
import { InstitutionProgram } from "../Institution";
import { Questionnaire, RequestAnswer } from "../Questionnaire";
import { HierarchicalCodeBook, PersonIdentification } from "../Shared";
import { Attachment } from "../Shared/Attachment";
import { LanguageCourseDecisionStatus } from "./LanguageCourseDecisionStatus";
import { OutsideEnrollmentAreaStatus } from "./OutsideEnrollmentAreaStatus";
import { PersonDetails } from "./PersonDetails";
import { RequestStatus } from "./RequestStatus";
import { RequestType } from "./RequestType";

export interface Request {
    id: number;
    code: string;
    requestUID: string;
    statusId: RequestStatus;
    type: RequestType;
    applicantParent?: PersonIdentification;
    applicantParentDetails?: PersonDetails;
    childDetails?: PersonDetails;
    otherParentDetails?: PersonDetails;
    schoolYearId: number;
    schoolYearCode?: string;
    institutionProgramId?: number;
    institutionProgram?: InstitutionProgram;

    institutionId?: number;
    commercialProgramId?: number;
    isOutsideEnrollmentArea: boolean;
    outsideEnrollmentAreaInstitutionProgramId?: number;
    outsideEnrollmentAreaInstitutionProgram?: InstitutionProgram;
    institutionChangeReason?: InstitutionChangeReason;
    institutionChangeReasonOther?: string;
    createdByAdmin: boolean;
    createdByAppUserId?: number;
    outsideEnrollmentAreaCommercialProgramId?: number;

    step: number;
    subStep?: number;
    schoolCandidateId?: number;
    institutionCommitteeId?: number;
    countyCommitteeId?: number;
    countyId?: number;

    mandatoryForeignLanguages?: HierarchicalCodeBook[];
    electiveSubjects?: HierarchicalCodeBook[];
    languageSchoolingModels?: HierarchicalCodeBook[];
    foreignLanguages?: HierarchicalCodeBook[];

    questionnaire?: Questionnaire;
    questionnaireAnswers?: RequestAnswer[];

    childUploadFiles?: UploadFile[];
    childAttachments?: Attachment[];
    educationalRehabilitationUploadFiles?: UploadFile[];
    educationalRehabilitationAttachments?: Attachment[];
    medicalUploadFiles?: UploadFile[];
    medicalAttachments?: Attachment[];
    otherUploadFiles?: UploadFile[];
    otherAttachments?: Attachment[];
    parentUploadFiles?: UploadFile[];
    parentAttachments?: Attachment[];
    psychologyUploadFiles?: UploadFile[];
    psychologyAttachments?: Attachment[];
    psychophysicalConditionDecisionUploadFiles?: UploadFile[];
    psychophysicalConditionDecisionAttachments?: Attachment[];
    uniqueBodyOfExpertiseUploadFiles?: UploadFile[];
    uniqueBodyOfExpertiseAttachments?: Attachment[];
    subsequentUploadFiles?: UploadFile[];
    subsequentAttachments?: Attachment[];

    suggestedEnrollmentOutsideEnrollmentArea?: boolean;
    approvedEnrollmentOutsideEnrollmentArea?: boolean;
    outsideEnrollmentAreaStatus?: OutsideEnrollmentAreaStatus;
    languageCourseDecisionStatus?: LanguageCourseDecisionStatus;

    enrollmentInstitutionId?: number;
}

export interface CommitteeDecision {
    id: number;
    requestId: number;
    committeeEmployeeId: number;
    committeeEmployee?: CommitteeEmployee;
    remark?: string;
    /**
     * This is no longer editable but it may be again in the future.
     */
    updatedDate: Date;
    committeeEnrollmentDecisionId: CommitteeEnrollmentDecision;
    committeeLanguageDecisionId?: CommitteeLanguageDecision;
    dateCreated: Date;
    dateUpdated?: Date;

    request?: Request;

    appUser?: AppUser;
    createdAppUser?: AppUser;
}

export interface AppUser {
    oib: string;
    firstName: string;
    lastName: string;
}

export enum CommitteeEnrollmentDecision {
        /// <summary>
        /// Spreman/spremna za upis<br/>
        /// Ready for enrollment
        /// </summary>
        Ready = 1,
        /// <summary>
        /// Nije spreman/spremna za upis<br/>
        /// Not ready for enrollment
        /// </summary>
        NotReady,
}

export enum CommitteeLanguageDecision {
        /// <summary>
        /// Nije potrebno uključivanje u pripremnu ili dopunsku nastavu hrvatskog jezika<br/>
        /// Supplementary or preparatory courses not required.
        /// </summary>
        NotRequired = 1,
        /// <summary>
        /// Potrebno uključivanje u pripremnu ili dopunsku nastavu hrvatskog jezika<br/>
        /// Supplementary or preparatory courses required.
        /// </summary>
        Required,
}

export enum InstitutionChangeReason
{
    ExtendedStay = 1,
    FullDayClasses,
    DevelopmentalDisabilities,
    BarrierFree,
    NationalMinorityLanguage,
    Tenancy,
    Relocation,
    FamilySituation,
    Other,
}
